import Logo from "./Logo";
import ContractCard from "./ContractCard";
import { TG_URL, DEX_URL, X_URL } from "../config";

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="relative border-t border-white/10 py-14">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-8 px-5 text-center">
        <div className="flex items-center gap-3">
          <Logo size={40} />
          <span className="font-display text-xl font-extrabold tracking-tight text-slate-50">
            MerrySolmas<span className="text-[#00F5D4]">.com</span>
          </span>
        </div>

        <ContractCard compact />

        <div className="flex flex-wrap items-center justify-center gap-6 font-mono-x text-xs uppercase tracking-[0.2em]">
          <a
            data-testid="footer-telegram-link"
            href={TG_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-400 transition-colors duration-200 hover:text-[#00F5D4]"
          >
            Telegram
          </a>
          <a
            data-testid="footer-x-link"
            href={X_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-400 transition-colors duration-200 hover:text-[#FF2B4A]"
          >
            X
          </a>
          <a
            data-testid="footer-dexscreener-link"
            href={DEX_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-400 transition-colors duration-200 hover:text-[#FF2B4A]"
          >
            Dexscreener
          </a>
        </div>

        <p className="max-w-2xl text-xs leading-relaxed text-slate-600">
          $SOLMAS is a community-takeover memecoin created for festive fun. Nothing on this site is financial advice.
          Crypto is risky — never spend more than you can afford to lose. CTO'd with love by the Solmas community.
        </p>
        <p className="font-mono-x text-[10px] uppercase tracking-[0.3em] text-slate-700">
          © 2026 MerrySolmas.com · See you on Dec 25
        </p>
      </div>
    </footer>
  );
}
